<div class="modulo modulo-lista">
      <div class="module-content">
            <div class="module-item" *ngFor="let d of data.lista" [ngSwitch]="d.tag">
                  <div *ngSwitchCase="'produto-em-destaque-categoria'">  
                        <modulo-produto-destaques [data]="d"></modulo-produto-destaques>
                  </div>
            </div>      
      </div>
</div>